import * as React from "react";
const SvgMeasuringTape = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M5.754 16.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
      fill="currentColor"
    />
    <path
      d="M3.5 5.5V13h-.75a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 0 .75.75h12.5A3.75 3.75 0 0 0 19 18.25V12h2.25a.75.75 0 0 0 .75-.75v-8.5a.75.75 0 0 0-.75-.75h-14a3.75 3.75 0 0 0-3.723 3.302.75.75 0 0 0-.027.198Zm13-2v1.75a.75.75 0 0 0 1.5 0V3.5h2.5v7h-1.587A3.251 3.251 0 0 0 15.75 8h-8.5a2.25 2.25 0 0 1 0-4.5h.25v2.75a.75.75 0 0 0 1.5 0V3.5h1.5v1.75a.75.75 0 0 0 1.5 0V3.5h1.5v2.75a.75.75 0 0 0 1.5 0V3.5h1.5Zm-1.25 17H8.797c.551-1 .748-2.148.695-3.224-.049-.974-.304-1.953-.738-2.776H10.5v1.75a.75.75 0 0 0 1.5 0V14.5h1.5v2.75a.75.75 0 0 0 1.5 0V14.5h.75c.644 0 1.245-.188 1.75-.51v4.26a2.25 2.25 0 0 1-2.25 2.25ZM5 13V8.75c.627.471 1.406.75 2.25.75h8.5a1.75 1.75 0 0 1 0 3.5H5Zm2.993 4.35c.059 1.185-.266 2.344-1.043 3.15H3.5v-6h3.444c.567.622.992 1.68 1.05 2.85Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgMeasuringTape;
